import { auth } from "@/services/api"

class AccessGroupsService {
  static indexPermissions () {
    return auth.get(`/permissions`).then((res) => res.data)
  }

  static updateStatus (id, obj) {
    return auth.put(`/update-status/${id}`, obj).then((res) => res.data)
  }

  static indexAcessGroups () {
    return auth.get(`/groups`).then((res) => res.data)
  }

  static getAcessGroup (id) {
    return auth.get(`/groups/${id}`).then((res) => res.data)
  }

  static updateAcessGroup (id, data) {
    return auth.put(`/groups/${id}`, data).then((res) => res.data)
  }

  static storeAcessGroups (data) {
    return auth.post(`/groups`, data).then((res) => res.data)
  }

  static deleteAcessGroup (id) {
    return auth.delete(`/groups/${id}`).then((res) => res.data)
  }
}

export default AccessGroupsService
